import React from 'react';
import { Route, Routes, Navigate } from 'react-router-dom';
import { RouteType } from '../../App.enums';
import { AppRoute } from '../../App.routing';
import { newGuid } from '../../Utils';
import Dashboard from './Dashboard/Dashboard';
import MyContent from './MyContent/MyContent';
import PendingRequests from './PendingRequests/PendingRequests';
import ApprovedRequests from './ApprovedRequests/ApprovedRequests';

export const routes: AppRoute[] = [
    {
        name: "Dashboard",
        icon: "k-icon k-i-thumbnails-up",
        type: RouteType.Main,
        path: "Dashboard",
        element: <Dashboard />
    },
    {
        name: "My Requests",
        icon: "k-icon k-i-file",
        type: RouteType.Main,
        path: "MyContent",
        element: <MyContent />
    },
    {
        name: "Library Requests",
        icon: "k-icon k-i-clock",
        type: RouteType.Main,
        path: "PendingRequests",
        element: <PendingRequests />
    },
    {
        name: "Closed Requests",
        icon: "k-icon k-i-check",
        type: RouteType.Main,
        path: "ApprovedRequests",
        element: <ApprovedRequests />
    },
];

function ContentGovernanceRouting() {
    return (
        <Routes>
            {routes.map(route => {
                return (<Route key={newGuid()} path={`${route.path}`} element={route.element} />);
            })}
            <Route path="/" element={<Navigate replace to="Dashboard" />} />
            <Route path="*" element={<Navigate replace to="Dashboard" />} />
        </Routes>
    );
}

export default ContentGovernanceRouting;
